import { render, staticRenderFns } from "./cpt-num-option.vue?vue&type=template&id=688e2120&scoped=true"
import script from "./cpt-num-option.vue?vue&type=script&lang=js"
export * from "./cpt-num-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e2120",
  null
  
)

export default component.exports